import * as React from "react";
const useHandleOnEscape = ({ handler }) => {
  const handleOnEscape = React.useCallback(
    (event) => {
      if (event.key === "Escape" || event.key === "Esc") {
        handler();
      }
    },
    [handler]
  );
  const registerHandleOnEscape = () => {
    document.addEventListener("keydown", handleOnEscape, false);
  };
  const deregisterHandleOnEscape = () => {
    document.removeEventListener("keydown", handleOnEscape, false);
  };
  return { registerHandleOnEscape, deregisterHandleOnEscape };
};
export {
  useHandleOnEscape
};
//# sourceMappingURL=use-handle-on-escape.js.map
